import application from 'application/application';

const controller = 'DefaultPublicationsAddDeadlineController';

application

	.controller(controller, [() => {}]);

export default controller;
